import domReady from '@wordpress/dom-ready';
import { initCounters } from '../../../assets/scripts/common/count-up';

domReady(() => {
  initCounters('.vertical-stats .vertical-stats__count', { lockWidth: false });
});
